import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TimeoutUnit, timeoutEditorValue } from '../duration/duration';

@Component({
  selector: 'app-timeout-editor',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './timeout-editor.component.html',
  styleUrl: './timeout-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeoutEditorComponent implements OnChanges {
  @Input({ required: true }) timeoutMilliseconds = 60_000;
  @Input() disabled = false;
  @Output() timeoutMillisecondsChange = new EventEmitter<number>();

  value = 1;
  unit: TimeoutUnit = 'minutes';

  ngOnChanges(): void {
    ({ value: this.value, unit: this.unit } = timeoutEditorValue(this.timeoutMilliseconds));
  }

  update(): void {
    const value = Math.max(1, Math.floor(Number(this.value) || 1));
    this.value = value;
    this.timeoutMillisecondsChange.emit(value * (this.unit === 'hours' ? 3_600_000 : 60_000));
  }
}
